import { queryPvDb, QueryTypes } from "./sqliteApi";
//function to round float. defaults to 2 decimal places.
export const roundToTwo = (num, decimalPlaces = 2) => {
  num = Math.round(num + "e" + decimalPlaces);
  return Number(num + "e" + -decimalPlaces);
};


const Material_eq = (Curve) => {
  let N = "";
  if (Curve === "A") N = "1";
  else if (Curve === "B") N = "2";
  else if (Curve === "C") N = "3";
  else if (Curve === "D") N = "4";
  else N = "Not A Carbon Steel";
  return N;
};

const MDMT66 = async (thickness, N) => {
  let MDMT = "";
  let Val = "";

  // Guard invalid thickness and clamp per UCS-66 lower bound
  const safeThickness = Number.isFinite(thickness) && thickness > 0 ? thickness : 6.4;
  const clampedThickness = safeThickness <= 6.4 ? 6.4 : safeThickness;

  if (N === "Not A Carbon Steel") {
    MDMT = "Not Available";
  } else {
    try {
      const response = await queryPvDb(
        "SELECT `" +
          N +
          "` FROM `MDMT-UCS66` ORDER BY ABS(Thickness - " +
          clampedThickness +
          ") LIMIT 1",
        { type: QueryTypes.SELECT }
      );
      if (response && response.length) {
        Val = response[0][N];
        MDMT = roundToTwo(Val, 2);
      } else {
        MDMT = null;
      }
    } catch (err) {
      console.error("[PV] MDMT66 query failed:", err);
      MDMT = null;
    }
  }
  return MDMT;
};

export const getFlangeMAWP = async (flangeRating, temp) => {
  console.log("flangeRating:", flangeRating, temp);
  let column = "";
  const table = "Flane Rating";
  let colValue = flangeRating;
  let selector = "Temp";
  let rowValue = temp;

  const response = await queryPvDb(`PRAGMA table_info("${table}")`, {
    type: QueryTypes.SELECT,
  });

  if (response.length > 0) {
    // response[i].name is the column name
    column = response
      .map((r) => r.name)
      .sort(
        (a, b) =>
          Math.abs(Number(a) - colValue) - Math.abs(Number(b) - colValue)
      )[0];
  }

  console.log(column);
  return await queryPvDb(
      "SELECT `" +
        column +
        "` FROM `" +
        table +
        "` ORDER BY ABS('" +
        selector +
        "' - " +
        rowValue +
        ") LIMIT 1",
      { type: QueryTypes.SELECT }
    )
    // await sequelize2.query(`SELECT ${column} FROM ${table} ORDER BY ABS(${selector} - ${rowValue}) LIMIT 1`, { type: QueryTypes.SELECT })
    .then((response) => {
      console.log("estimate of name:", response[0][column]);
      return response[0][column];
      // tempObject[name] = response[0][column]
    });
};

export const getMDMT = async (material, thickness) => {
  let N = "";
  let MDMT = "";

  try {
    const response = await queryPvDb(
      'select `MDMT Curve 1` from `MDMT Curve 1` where Material = "' +
        material +
        '" LIMIT 1',
      { type: QueryTypes.SELECT }
    );
    if (response && response.length) {
      N = Material_eq(response[0]["MDMT Curve 1"]);
    } else {
      N = "Not A Carbon Steel";
    }
  } catch (err) {
    console.error("[PV] getMDMT: failed to fetch curve for material:", material, err);
    N = "Not A Carbon Steel";
  }

  // Guard invalid thickness upstream as well
  const safeThickness = Number.isFinite(thickness) && thickness > 0 ? thickness : 6.4;
  MDMT = await MDMT66(safeThickness, N);
  return MDMT;
};

export const Cylindrical_Shell_Calc = (input) => {
  var Design_Pressure = parseFloat(input.txt_DP_CSC);
  var Allowable_Stress = parseFloat(input.txt_AS_CSC);
  var Joint_Efficiency = parseFloat(input.txt_JE_CSC);
  var Diameter = parseFloat(input.txt_ID_CSC);
  var Provided_Thickness = parseFloat(input.txt_PT_CSC);
  // key2.Item("Material Allowable Stress" + Material + "-" + txtDTemp.Text)(0)
  var Corrosion_Allowance = parseFloat(input.txt_CA_CSC);
  var Req_Shell_Thickness;
  var A_Factor;
  var B_Factor;
  var Total_Length_L = parseFloat(input.txt_DL_CSC);
  var MAWP_Max_Working_Pressure;
  var MAPNC_Max_Pressure_NC;
  var Do_t_Ratio;
  var L_Do_Ratio;
  var Max_Allowable_Stress_Pa;
  var Liquid_Head;
  var Density = parseFloat(input.TextBox30) / 10 ** 9;
  var Gravity = 9.81;
  var Height = parseFloat(input.TextBox66) * 1000;
  var Design_Pressure_New;
  var Hydrostatic_Head_Pressure = 0.02;
  var CAE = 0;
  var Modulus_of_Elasticity = (2.97 * 10000000) / 145;
  var Do_Diameter;
  var Effective_Length_Lc;

  var result = {};

  Liquid_Head = Density * Gravity * Height;
  result["txt_LH_CSC"] = roundToTwo(Liquid_Head);

  Design_Pressure_New = Design_Pressure + Liquid_Head; //1 + (0.1)
  console.log(
    "Design_Pressure: ",
    Design_Pressure,
    Liquid_Head,
    Design_Pressure_New
  );
  // result["txt_DP_CSC"] = Design_Pressure_New

  if (input.ComboBox7 === "ID") {
    result["Label1026"] = "Inside Diameter";
    //Shell_Thickness
    result["Label1003"] =
      "Tr = (P * (D / 2 + CA)) / (S * E - 0.6 * P) per UG-27 (c) (1)";
    result["Label6"] =
      "=  ( " +
      roundToTwo(Design_Pressure_New) +
      " * " +
      Diameter +
      " /  2" +
      " + " +
      Corrosion_Allowance +
      "  )  /  ( " +
      Allowable_Stress +
      " * " +
      Joint_Efficiency +
      " - " +
      0.6 +
      " * " +
      roundToTwo(Design_Pressure_New) +
      " ) ";
    result["Label6"] =
      "=  ( " +
      roundToTwo(Design_Pressure_New) +
      " * " +
      Diameter +
      " /  2" +
      " + " +
      Corrosion_Allowance +
      "  )  /  ( " +
      Allowable_Stress +
      " * " +
      Joint_Efficiency +
      " - " +
      0.6 +
      " * " +
      roundToTwo(Design_Pressure_New) +
      " ) ";
    Req_Shell_Thickness =
      (Design_Pressure_New * (Diameter / 2 + Corrosion_Allowance)) /
      (Allowable_Stress * Joint_Efficiency - 0.6 * Design_Pressure_New);
    result["Label6a"] =
      "= " +
      roundToTwo(Req_Shell_Thickness) +
      " + " +
      Corrosion_Allowance;

    //MAWP
    result["Label1001"] =
      "MAWP = (S * E * (T - CA - CAE)) / ((D / 2 + CA) + 0.6 * (T - CA - CAE)) per UG-27 (c) (1)";
    result["Label7"] =
      "=  (" +
      Allowable_Stress +
      " * " +
      Joint_Efficiency +
      " * (" +
      Provided_Thickness +
      " - " +
      Corrosion_Allowance +
      " - " +
      CAE +
      ") / (" +
      Diameter +
      " /  2  + " +
      Corrosion_Allowance +
      ")  +  0.6  (" +
      Provided_Thickness +
      " - " +
      Corrosion_Allowance +
      " - " +
      CAE +
      "))";
    MAWP_Max_Working_Pressure =
      (Allowable_Stress *
        Joint_Efficiency *
        (Provided_Thickness - Corrosion_Allowance - CAE)) /
        (Diameter / 2 +
          Corrosion_Allowance +
          0.6 * (Provided_Thickness - Corrosion_Allowance - CAE)) -
      Hydrostatic_Head_Pressure;

    //MANPC
    result["Label1002"] =
      "MAPNC = ( SA * E * T ) / ( D/2 + 0.6 * T ) per UG-27 (c) (1)";
    result["Label8"] =
      "= (" +
      roundToTwo(Allowable_Stress) +
      " * " +
      Joint_Efficiency +
      " * " +
      Provided_Thickness +
      ") / (" +
      Diameter +
      " / 2 " +
      " +  0.6  *  " +
      roundToTwo(Provided_Thickness) +
      ") ";
    MAPNC_Max_Pressure_NC =
      (Allowable_Stress * Joint_Efficiency * Provided_Thickness) /
      (Diameter / 2 + 0.6 * Provided_Thickness);
  } else if (input.ComboBox7 === "OD") {
    result["Label1026"] = "Outside Diameter";

    //Shell_Thickness
    result["Label1003"] =
      "Tr = (P * (D / 2 - CAE)) / (S * E + 0.4 * P) per Appendix 1-1 (a) (1)";
    result["Label1003"] =
      "=  ( " +
      roundToTwo(Design_Pressure_New) +
      " * " +
      Diameter +
      " /  2" +
      "  )  /  ( " +
      Allowable_Stress +
      " * " +
      Joint_Efficiency +
      " + " +
      0.4 +
      " * " +
      roundToTwo(Design_Pressure_New) +
      " ) ";
    Req_Shell_Thickness =
      (Design_Pressure_New * (Diameter / 2)) /
      (Allowable_Stress * Joint_Efficiency + 0.4 * Design_Pressure_New);

    //MAWP
    result["Label1001"] =
      "MAWP = ( S * E * (T - CA)) / ((D/2) - 0.4 * (T-CA)) per Appendix 1-1 (a) (1)";
    result["Label7"] =
      "=  (" +
      roundToTwo(Allowable_Stress) +
      " * " +
      Joint_Efficiency +
      " * (" +
      Provided_Thickness +
      " - " +
      Corrosion_Allowance +
      ") / (" +
      Diameter +
      " /  2  )  -  0.4  (" +
      Provided_Thickness +
      " - " +
      Corrosion_Allowance +
      " - " +
      ")";
    MAWP_Max_Working_Pressure =
      (Allowable_Stress *
        Joint_Efficiency *
        (Provided_Thickness - Corrosion_Allowance - CAE)) /
        (Diameter / 2 +
          Corrosion_Allowance -
          0.4 * (Provided_Thickness - Corrosion_Allowance - CAE)) -
      Hydrostatic_Head_Pressure;

    //MAPNC
    result["Label1002"] =
      "MAPNC = ( SA * E * T ) / ( D/2 - 0.4 * T ) per Appendix 1-1 (a) (1)";
    result["Label8"] =
      "=  (" +
      roundToTwo(Allowable_Stress) +
      " * " +
      Joint_Efficiency +
      " * " +
      Provided_Thickness +
      ")  /  (" +
      Diameter +
      " /  2 " +
      " -  0.4  *  " +
      roundToTwo(Provided_Thickness) +
      ")";
    MAPNC_Max_Pressure_NC =
      (Allowable_Stress * Joint_Efficiency * Provided_Thickness) /
      (Diameter / 2 - 0.4 * Provided_Thickness);
  } else {
    //return null?
  }

  Do_Diameter = Diameter + 2 * Provided_Thickness;
  var New_Thickness;
  New_Thickness = Provided_Thickness - Corrosion_Allowance;
  Do_t_Ratio = Do_Diameter / New_Thickness;
  result["TextBox75"] = roundToTwo(Do_t_Ratio);

  var New_Length_Lf;
  New_Length_Lf = Total_Length_L + Do_Diameter / 6;
  Effective_Length_Lc =
    1.14 *
    (1 - 0.3 ** 2) ** 0.25 *
    Do_Diameter *
    (Do_Diameter / Provided_Thickness) ** 0.5;

  L_Do_Ratio = New_Length_Lf / Do_Diameter;
  result["TextBox74"] = roundToTwo(L_Do_Ratio);

  let Value_1 = 1.1 * (Provided_Thickness / Do_Diameter) ** 2;
  let Value_2 = 1.3 / (L_Do_Ratio * Do_t_Ratio ** 1.5);

  if (Value_1 > Value_2) {
    A_Factor = Value_1;
  } else if (Value_2 > Value_1) {
    A_Factor = Value_2;
  }

  result["txt_AF_CSC"] = roundToTwo(A_Factor, 5);

  Max_Allowable_Stress_Pa =
    (2 * A_Factor * Modulus_of_Elasticity) / (3 * Do_t_Ratio);
  result["TextBox63"] = roundToTwo(Max_Allowable_Stress_Pa);

  B_Factor = (Max_Allowable_Stress_Pa * 3 * Do_t_Ratio) / 4;
  result["txt_BF_CSC"] = roundToTwo(B_Factor);

  //Result
  result["TextBox108"] = roundToTwo(
    Req_Shell_Thickness + Corrosion_Allowance
  );
  result["TextBox113"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["TextBox114"] = roundToTwo(MAPNC_Max_Pressure_NC);
  result["TextBox106"] = roundToTwo(
    Req_Shell_Thickness + Corrosion_Allowance
  );
  result["TextBox85"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["TextBox107"] = roundToTwo(MAPNC_Max_Pressure_NC);
  result["TextBox182"] = roundToTwo(MAWP_Max_Working_Pressure * 1.3);
  result["TextBox183"] = roundToTwo(
    MAPNC_Max_Pressure_NC * 1.3 - Liquid_Head
  );
  result["TextBox184"] = 0.518;
  result["TextBox185"] = -6;
  result["TextBox24"] = roundToTwo(Max_Allowable_Stress_Pa);
  result["TextBox5"] = roundToTwo(Do_t_Ratio);
  result["TextBox4"] = roundToTwo(L_Do_Ratio);

  // console.log(result)
  //return the object
  return result;
};

export const Elliptical_Head_Calc = (input) => {
  var Design_Pressure = parseFloat(input.txt_DP_EHC);
  var Allowable_Stress = parseFloat(input.txt_AS_EHC);
  var Joint_Efficiency = parseFloat(input.txt_JE_EHC);
  var Diameter = parseFloat(input.txt_ID_EHC);
  var Provided_Thickness = parseFloat(input.txt_PT_EHC);
  console.log("Provided_Thickness:", Provided_Thickness);

  var Corrosion_Allowance = parseFloat(input.txt_CA_EHC);
  var CAE = roundToTwo(0.1875);
  var K = 1;
  var Req_Head_Thickness;
  var MAWP_Max_Working_Pressure;
  var MAPNC_Max_Pressure_NC;
  var Coefficient;
  var Do_t_Ratio;
  var B_Factor = parseFloat(input.txt_BF_EHC);
  var A_Factor;
  var Max_Allowable_Stress_Pa;
  var Density = parseFloat(input.TextBox30) / 10 ** 9;
  var Gravity = 9.81;
  var Height = parseFloat(input.TextBox66) * 1000;
  var Design_Pressure_New;
  var Liquid_Head;
  var Hydrostatic_Head_Pressure = 0.02;
  var Do_Diameter;
  var R;
  var Modulus_of_Elasticity = (2.97 * 10000000) / 145;
  var New_Thickness;

  Do_Diameter = Diameter + 2 * Provided_Thickness;

  R = 0.9 * Do_Diameter;

  var result = {};

  Liquid_Head = Density * Gravity * Height;
  result["txt_LH_EHC"] = roundToTwo(Liquid_Head);

  Design_Pressure_New = Design_Pressure + Liquid_Head;
  // result["txt_DP_CSC"] = Design_Pressure_New

  New_Thickness = Provided_Thickness - Corrosion_Allowance;
  Do_t_Ratio = R / New_Thickness;
  result["txt_D_T_EHC"] = roundToTwo(Do_t_Ratio);
  result["text_Do_2"] = roundToTwo(Do_t_Ratio);

  A_Factor = 0.125 / Do_t_Ratio;
  result["txt_AF_EHC"] = roundToTwo(A_Factor, 5);

  Max_Allowable_Stress_Pa = (0.0625 * Modulus_of_Elasticity) / Do_t_Ratio ** 2;
  result["txt_EMAWP_EHC"] = roundToTwo(Max_Allowable_Stress_Pa);
  result["text_MAP"] = roundToTwo(Max_Allowable_Stress_Pa);

  if (input.ComboBox7 === "ID") {
    result["Label455"] = "Inside Diameter";

    //Thickness
    result["Label461"] =
      "Tr = ( P * (D + 2 * CA) * K) / (2 * S * E-0.2 * P) Appendix 1-4 (c)";
    result["Label9"] =
      "=  ( " +
      roundToTwo(Design_Pressure_New) +
      " * ( " +
      Diameter +
      " + 2  * " +
      Corrosion_Allowance +
      " ) * " +
      K +
      ") / ( 2 * " +
      Allowable_Stress +
      " * " +
      Joint_Efficiency +
      "  -  0.2 * " +
      roundToTwo(Design_Pressure_New) +
      " ) ";
    Req_Head_Thickness =
      (Design_Pressure_New * (Diameter + 2 + Corrosion_Allowance) * K) /
      (2 * Allowable_Stress * Joint_Efficiency - 0.2 * Design_Pressure_New);
    console.log(
      "Req_Head_Thickness:",
      Req_Head_Thickness,
      "sssssssss",
      Corrosion_Allowance
    );

    //MAWP
    result["Label465"] =
      "MAWP = (2 * S * E *( T - CA - CAE )) / ( K * ( D / 2 + CA ) + 0.2 * ( T - CA - CAE )) per Appendix 1-4 (c)";
    result["Label30"] =
      "= ( 2 * " +
      Allowable_Stress +
      " * " +
      Joint_Efficiency +
      " * ( " +
      Provided_Thickness +
      " - " +
      Corrosion_Allowance +
      " * " +
      CAE +
      " )) / ( " +
      K +
      " * ( " +
      Diameter +
      " / 2 + " +
      CAE +
      " + 0.2 * ( " +
      Provided_Thickness +
      " - " +
      Corrosion_Allowance +
      " - " +
      CAE +
      " ))) ";
    //HERE * CAE and + K IS MISSIGN?! Corrosion_Allowance + " * " + CAE + " )) / ( " + K + " * ( "
    MAWP_Max_Working_Pressure =
      (2 *
        Allowable_Stress *
        Joint_Efficiency *
        (Provided_Thickness - Corrosion_Allowance)) /
      (Diameter +
        0.2 * Corrosion_Allowance +
        0.2 *
          (Provided_Thickness -
            Corrosion_Allowance -
            Hydrostatic_Head_Pressure));
    // MAWP_Max_Working_Pressure = (2 * Allowable_Stress * Joint_Efficiency * (Provided_Thickness - Corrosion_Allowance)) / (K* Diameter/2 + CAE+0.2*(Provided_Thickness - Corrosion_Allowance - CAE)) - Hydrostatic_Head_Pressure
    console.log("NUL VALL??: ", MAWP_Max_Working_Pressure);

    //MANPC
    result["Label469"] =
      "MAPNC = ( 2 * SA * E * T ) / (K * D + 0.2 * T ) per Appendix 1-4 (c)";
    result["Label34"] =
      " = ( 2 * " +
      Allowable_Stress +
      " * " +
      Joint_Efficiency +
      " * " +
      Provided_Thickness +
      " ) / ( " +
      K +
      " * " +
      Diameter +
      " + 0.2 * " +
      Provided_Thickness +
      " )) ";
    MAPNC_Max_Pressure_NC =
      (2 * Allowable_Stress * Joint_Efficiency * Provided_Thickness) /
      (Diameter + 0.2 * Provided_Thickness);
  } else if (input.ComboBox7 === "OD") {
    result["Label455"] = "Outside Diameter";

    //Thickness
    result["Label461"] =
      "Tr = ( P * ( D - 2 * CAE ) * K) / ( 2 * S * E + 2 * P * ( K-0.1 )) Appendix 1-4 (c)";
    result["Label9"] =
      "=  ( " +
      roundToTwo(Design_Pressure_New) +
      " * ( " +
      Diameter +
      " - ( 2  * " +
      CAE +
      " ) * " +
      K +
      " )) / (( 2 * " +
      roundToTwo(Allowable_Stress) +
      " * " +
      Joint_Efficiency +
      " ) + ( 2 * " +
      roundToTwo(Design_Pressure_New) +
      " ) * ( " +
      K -
      0.1 +
      " )) ";
    var Req_Shell_Thickness =
      (Design_Pressure_New * (Diameter - 2 * 0 * K)) /
      (2 * Allowable_Stress * Joint_Efficiency +
        2 * Design_Pressure_New * (K - 0.1));

    //MAWP
    result["Label465"] =
      "MAWP = ( 2 * S * E * (T - CA - CAE)) / (K * (D - 2 * CA) - 2 * (T - CA - CAE)*(K - 0.1)) per Appendix 1-4 (c)";
    result["Label30"] =
      "= ( 2 * " +
      Allowable_Stress +
      " * " +
      Joint_Efficiency +
      " * ( " +
      Provided_Thickness +
      " - " +
      Corrosion_Allowance +
      " )) / ( " +
      K +
      " * ( " +
      Diameter +
      " - 2 * " +
      CAE +
      " - 2 * ( " +
      Provided_Thickness +
      " - " +
      Corrosion_Allowance +
      " ) * ( " +
      K +
      " - 0.1 ))) ";
    MAWP_Max_Working_Pressure =
      (2 *
        Allowable_Stress *
        Joint_Efficiency *
        (Provided_Thickness - Corrosion_Allowance)) /
        (K * (Diameter - 2 * Corrosion_Allowance) -
          2 * (Provided_Thickness - Corrosion_Allowance) * (K - 0.1)) -
      Hydrostatic_Head_Pressure;

    //MAPNC
    result["Label469"] =
      "MAPNC = ( 2 * SA * E * T ) / (K * D + 0.2 * T * (K - 0.1)) per Appendix 1-4 (c)";
    result["Label34"] =
      " = ( 2 * " +
      Allowable_Stress +
      " * " +
      Joint_Efficiency +
      " * " +
      Provided_Thickness +
      " ) / ( " +
      K +
      " * " +
      Diameter +
      " + 0.2 * " +
      Provided_Thickness +
      " * ( " +
      (K - 0.1) +
      " ) ";
    MAPNC_Max_Pressure_NC =
      (2 * Allowable_Stress * Joint_Efficiency * Provided_Thickness) /
      (Diameter + 0.2 * Provided_Thickness * (K - 0.1));
  } else {
    //return null?
  }

  result["Label9a"] = Req_Head_Thickness + "+" + Corrosion_Allowance;
  //Result
  result["txt_TR_EHC"] = roundToTwo(
    Req_Head_Thickness + Corrosion_Allowance
  );
  result["txt_MAWP_EHC"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["txt_MAPNC_EHC"] = roundToTwo(MAPNC_Max_Pressure_NC);
  result["TextBox118"] = roundToTwo(
    Req_Head_Thickness + Corrosion_Allowance
  );
  result["TextBox119"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["TextBox120"] = roundToTwo(MAPNC_Max_Pressure_NC);
  result["TextBox121"] = roundToTwo(MAWP_Max_Working_Pressure * 1.3);
  result["TextBox122"] = roundToTwo(MAPNC_Max_Pressure_NC * 1.3);
  result["TextBox123"] = 1.704;
  result["TextBox124"] = -20;

  //return the object
  return result;
};

export const Shell_Calc = async (input, calcResult) => {
  //input is datagridview5
  let DataGridView6 = [];
  var tempObject = {};
  let N = "";
  for (const row of input.DataGridView5) {
    await queryPvDb(
        'select `Allowable Stress (N/mm^2)` from`Material Allowable Stress` where Material = "' +
          row.Material +
          '" LIMIT 1',
        { type: QueryTypes.SELECT }
      )
      .then((response) => {
        tempObject["Allowable_Stress"] =
          response[0]["Allowable Stress (N/mm^2)"];
      });
    // await sequelize2.query('select `MDMT Curve 1` from `MDMT Curve 1` where Material = "' + row.Material + '" LIMIT 1', { type: QueryTypes.SELECT })
    //     .then(response => {
    //         tempObject["UCS_Curve"] = response[0]["MDMT Curve 1"]
    //         if (tempObject["UCS_Curve"] === "A")
    //             N = 1
    //         else if (tempObject["UCS_Curve"] === "B")
    //             N = 2
    //         else if (tempObject["UCS_Curve"] === "C")
    //             N = 3
    //         else if (tempObject["UCS_Curve"] === "D")
    //             N = 4
    //         else
    //             N = "Not A Carbon Steel"
    //     })
    // if (N === "Not A Carbon Steel") {
    //     tempObject["MDMT"] = "NA"
    // }
    // else {
    //     await sequelize2.query('SELECT `' + N + '` FROM `MDMT-UCS66` ORDER BY ABS(Thickness - ' + calcResult["Cylindrical"].TextBox106 + ') LIMIT 1', { type: QueryTypes.SELECT })
    //         .then(response => {
    //             tempObject["MDMT"] = response[0][N]
    //         })
    // }

    // SELECT `column_name` FROM information_schema.columns WHERE table_name = 'shell_man_hours'
    // ORDER BY ABS((9 - column_name)) ;

    if (
      row.Component === "2:1 S.E Head (L/B)" ||
      row.Component === "2:1 S.E Head (R/T)"
    )
      DataGridView6.push({
        ...tempObject,
        MDMT: await getMDMT(
          row.Material,
          calcResult["Cylindrical"].TextBox106
        ),
        UCS_Curve: await queryPvDb(
            'select `MDMT Curve 1` from `MDMT Curve 1` where Material = "' +
              row.Material +
              '" LIMIT 1',
            { type: QueryTypes.SELECT }
          )
          .then((response) => response[0]["MDMT Curve 1"]),
        Required_Thickness: calcResult["Elliptical"].TextBox118,
        MAWP: calcResult["Elliptical"].TextBox119,
        Hydrotest_Pressure: calcResult["Elliptical"].TextBox121,
      });
    else if (row.Component === "Cylindrical Shell")
      DataGridView6.push({
        ...tempObject,
        MDMT: await getMDMT(
          row.Material,
          calcResult["Cylindrical"].TextBox106
        ),
        UCS_Curve: await queryPvDb(
            'select `MDMT Curve 1` from `MDMT Curve 1` where Material = "' +
              row.Material +
              '" LIMIT 1',
            { type: QueryTypes.SELECT }
          )
          .then((response) => response[0]["MDMT Curve 1"]),
        Required_Thickness: calcResult["Cylindrical"].TextBox106,
        MAWP: calcResult["Cylindrical"].TextBox85,
        Hydrotest_Pressure: calcResult["Cylindrical"].TextBox182,
      });
    else if (row.Component === "Conical Shell")
      DataGridView6.push({ ...tempObject });
    // console.log(Allowable_Stress.data);
  }
  return DataGridView6;
  // console.log("DataGridView6", DataGridView6)
  //For parallel read
  //  await Promise.all(files.map(async (file) => {
  //     const contents = await fs.readFile(file, 'utf8')
  //     console.log(contents)
  //   }));
};

export const Nozzle_Calc_1 = async (input, Nozzle) => {
  var Design_Pressure_P = parseFloat(input?.txt_DP_NC1);
  var Shell_Material = parseFloat(input?.txt_SM_NC1);
  var Shell_AS_S = parseFloat(input?.txt_SAS_NC1);
  var Shell_Diameter_D = parseFloat(input?.txt_SD_NC1);
  var Shell_JE_E = parseFloat(input?.TextBox31);
  var Shell_Pvd_Thickness_T = parseFloat(input?.txt_SPT_NC1);
  var Nozzle_Material = parseFloat(input?.txt_NM_NC1);
  var Nozzle_As_SN = parseFloat(input?.txt_NAS_NC1);
  var Nozzle_Diameter_ND = parseFloat(input?.txt_ND_NC1);
  const ndRows = await queryPvDb(
      "Select `Nominal DIa` from `nozzle diameter thickness` where `Nozzle Size` = ? and `Sch` = ? LIMIT 1",
      {
        replacements: [
          input["DataGridView1"][Nozzle]["Size"],
          input["DataGridView1"][Nozzle]["Sch/Thk"],
        ],
        type: QueryTypes.SELECT,
      }
    )
    .catch(() => []);
  if (ndRows.length) {
    const dbVal = parseFloat(ndRows[0]["Nominal DIa"]);
    if (Number.isFinite(dbVal)) Nozzle_Diameter_ND = dbVal;
  }
  const ndError = !Number.isFinite(Nozzle_Diameter_ND);
  // A4 = (Weld_bw_Nozzle_Vessel_WO * Weld_bw_Nozzle_Vessel_WO * FFR2) + (Nozzle_Weld_Inside_WI * Nozzle_Weld_Inside_WI * FFR2)
  var Nozzle_JE_NE = parseFloat(input?.TextBox31);
  var Weld_bw_Nozzle_Vessel_WO = parseFloat(input?.txt_FWSI_NC1);
  var Inside_Proj_H = parseFloat(input?.txt_FWSO_NC1);
  if (!input.txt_FWSO_NC1) {
    Inside_Proj_H = input["DataGridView1"][Nozzle]["Nozzle Weld (A)"];
  }
  var Outside_Proj_HO;
  var Nozzle_Weld_A;
  var Inside_Weld_B;
  var Pad_Weld_C;
  var Nozzle_Weld_Inside_WI = parseFloat(input.txt_FWSI_NC1);
  Nozzle_Weld_Inside_WI = input["DataGridView1"][Nozzle]["Inside Proj"];
  Weld_bw_Nozzle_Vessel_WO = input["DataGridView1"][Nozzle]["Inside Proj"];
  var Nozzle_Pvd_Thickness_Tn = parseFloat(input.txt_NPT_NC1);
  const tnRows = await queryPvDb(
      "Select `Pvd. thk.` from `nozzle diameter thickness` where `Nozzle Size` = ? and `Sch` = ? LIMIT 1",
      {
        replacements: [
          input["DataGridView1"][Nozzle]["Size"],
          input["DataGridView1"][Nozzle]["Sch/Thk"],
        ],
        type: QueryTypes.SELECT,
      }
    )
    .catch(() => []);
  if (tnRows.length) {
    const dbVal = parseFloat(tnRows[0]["Pvd. thk."]);
    if (Number.isFinite(dbVal)) Nozzle_Pvd_Thickness_Tn = dbVal;
  }
  const tnError = !Number.isFinite(Nozzle_Pvd_Thickness_Tn);
  var Req_Shell_Thickness_Tr;
  var Req_Nozzle_Thickness_Trn;
  var Pad_Dia = input["DataGridView1"][Nozzle]["Pad OD"];
  var CAS = 0;
  var CAE = 0;
  var CAN = 0;
  var ES = 1;
  var FFR1 = 1;
  var FFR2 = 1;
  var FFR4 = 1;
  var Minimum;
  var TLNP = 2.5 * Nozzle_Pvd_Thickness_Tn;
  var Ar;
  var A1;
  var A2;
  var A3;
  var A4;
  var A5;
  var Total_Area;

  var result = {};

  result["txt_ND_NC1"] = ndError ? "Db Error" : roundToTwo(Nozzle_Diameter_ND);
  result["txt_NPT_NC1"] = tnError ? "Db Error" : roundToTwo(Nozzle_Pvd_Thickness_Tn);
  result["txt_FWSI_NC1"] = roundToTwo(Nozzle_Weld_Inside_WI);
  result["txt_FWSO_NC1"] = roundToTwo(Weld_bw_Nozzle_Vessel_WO);
  Outside_Proj_HO = input.DataGridView1[Nozzle]["Outside Proj"];

  if (input["DataGridView1"][Nozzle]["Weld Detail"] === "1") {
    Nozzle_Weld_A = input["DataGridView1"][Nozzle]["Nozzle Weld (A)"];
    Inside_Weld_B = input["DataGridView1"][Nozzle]["Inside Weld (B)"];
    Pad_Weld_C = 0;
    Inside_Proj_H = input["DataGridView1"][Nozzle]["Inside Proj"];
  } else if (input["DataGridView1"][Nozzle]["Weld Detail"] === "2") {
    Nozzle_Weld_A = input["DataGridView1"][Nozzle]["Nozzle Weld (A)"];
    Inside_Weld_B = 0;
    Pad_Weld_C = 0;
    Inside_Proj_H = 0;
  } else {
    Nozzle_Weld_A = input["DataGridView1"][Nozzle]["Nozzle Weld (A)"];
    Inside_Weld_B = input["DataGridView1"][Nozzle]["Inside Weld (B)"];
    Pad_Weld_C = input["DataGridView1"][Nozzle]["Pad Weld (C)"];
    Inside_Proj_H = input["DataGridView1"][Nozzle]["Inside Proj"];
  }
  if (ndError || tnError) {
    result["txt_TRN_NC1"] = "Db Error";
    result["txt_AR_NC1"] = "Db Error";
    result["txt_AA_NC1"] = "Db Error";
    result["Actual_Weld_Size_A"] = roundToTwo((parseFloat(Nozzle_Weld_A) || 0) * 0.707);
    result["Actual_Weld_Size_B"] = roundToTwo((parseFloat(Inside_Weld_B) || 0) * 0.707);
    result["Actual_Weld_Size_C"] = roundToTwo((parseFloat(Pad_Weld_C) || 0) * 0.707);
    return result;
  }
  // console.log("varred", com)
  if (input.ComboBox7 === "ID") {
    result["Label270"] =
      "For Shell : tr = (P * (D/2 - CAE)) / ((S * E) - (0.6 * P)),";
    result["Label43"] =
      "= (" +
      Design_Pressure_P +
      " * " +
      Shell_Diameter_D / 2 +
      " )) / (( " +
      Shell_AS_S +
      " * " +
      Shell_JE_E +
      " ) - ( 0.6 * " +
      Design_Pressure_P +
      " ))";
    Req_Shell_Thickness_Tr = roundToTwo(
      parseFloat(Design_Pressure_P * (Shell_Diameter_D / 2 - CAE)) /
        (Shell_AS_S * Shell_JE_E - 0.6 * Design_Pressure_P)
    );
    result["Label367"] =
      "For Nozzle : trn = (P * (Dn / 2 - CAE)) / ((S * E) - (0.6 * P)),";
    result["Label44"] =
      "= (" +
      Design_Pressure_P +
      " * " +
      Nozzle_Diameter_ND / 2 +
      " )) / (( " +
      Nozzle_As_SN +
      " * " +
      Nozzle_JE_NE +
      " ) - ( 0.6 * " +
      Design_Pressure_P +
      " ))";
    // result["Label44"] = (( Design_Pressure_P  *  Nozzle_Diameter_ND / 2  )) / ((  Nozzle_As_SN  * Nozzle_JE_NE  ) - ( 0.6 * Design_Pressure_P  ))
    Req_Nozzle_Thickness_Trn =
      (Design_Pressure_P * (Nozzle_Diameter_ND / 2)) /
      (Nozzle_As_SN * Nozzle_JE_NE - 0.6 * Design_Pressure_P);
  } else if (input.ComboBox7 === "OD") {
    result["Label270"] =
      "For Shell : tr = (P * D/2 - CAE) / ((S * E) + (0.4 * P)),";
    result["Label43"] =
      "= (" +
      Design_Pressure_P +
      " * " +
      Shell_Diameter_D / 2 +
      " )) / (( " +
      Shell_AS_S +
      " * " +
      Shell_JE_E +
      " ) + ( 0.4 * " +
      Design_Pressure_P +
      " ))";
    Req_Shell_Thickness_Tr =
      parseFloat(Design_Pressure_P * (Shell_Diameter_D / 2 - CAE)) /
      (Shell_AS_S * Shell_JE_E + 0.4 * Design_Pressure_P);
    result["Label367"] =
      "For Nozzle : trn = (P * (Dn / 2 - CAE)) / ((S * E) + (0.4 * P)),";
    result["Label44"] =
      "= (" +
      Design_Pressure_P +
      " * " +
      Nozzle_Diameter_ND / 2 +
      " )) / (( " +
      Nozzle_As_SN +
      " * " +
      Nozzle_JE_NE +
      " ) + ( 0.4 * " +
      Design_Pressure_P +
      " ))";
    Req_Nozzle_Thickness_Trn =
      (Design_Pressure_P * (Nozzle_Diameter_ND / 2)) /
      (Nozzle_As_SN * Nozzle_JE_NE + 0.4 * Design_Pressure_P);
  } else {
    //return null?
  }

  result["txt_TR_NC1"] = Req_Shell_Thickness_Tr;
  result["txt_TRN_NC1"] = Req_Nozzle_Thickness_Trn;
  result["txt_TR_NC1"] = roundToTwo(Req_Shell_Thickness_Tr);
  result["txt_TRN_NC1"] = roundToTwo(Req_Nozzle_Thickness_Trn);

  var DL = Nozzle_Diameter_ND;
  var DLR = roundToTwo(DL / 2);
  console.log(
    DL +
      "/ 2) * " +
      Req_Shell_Thickness_Tr +
      " 2 *" +
      Nozzle_Pvd_Thickness_Tn +
      "*" +
      Req_Shell_Thickness_Tr +
      " * (1 -" +
      FFR1
  );
  Ar =
    (DL / 2) * Req_Shell_Thickness_Tr +
    2 * Nozzle_Pvd_Thickness_Tn * Req_Shell_Thickness_Tr * (1 - FFR1);
  console.log(Ar, DL, Req_Shell_Thickness_Tr, Nozzle_Pvd_Thickness_Tn);
  result["txt_AR_NC1"] = Ar;
  result["txt_AR_NC1"] = roundToTwo(Ar);

  A1 =
    (DL - DLR) * (ES * (Shell_Pvd_Thickness_T - CAS) - Req_Shell_Thickness_Tr) -
    2 *
      (Nozzle_Pvd_Thickness_Tn - CAN) *
      (ES * (Shell_Pvd_Thickness_T - CAS) - Req_Shell_Thickness_Tr) *
      (1 - FFR1);
  result["labelA1"] = `= (${roundToTwo(DL)}- ${DLR}) * (${ES}
     * (${Shell_Pvd_Thickness_T} - ${CAS}) - ${Req_Shell_Thickness_Tr} ) - 2 * (${
    Nozzle_Pvd_Thickness_Tn - CAN
  }
       ) * (${ES} * (${Shell_Pvd_Thickness_T} - ${CAS}) - ${roundToTwo(
    Req_Shell_Thickness_Tr
  )} ) * (1 - ${FFR1})`;

  // result["labelA1"] = "=(" + roundToTwo(DL) + " - " + DLR + ") * (" + ES + " * (" + Shell_Pvd_Thickness_T + "-" + CAS + ") - " + Req_Shell_Thickness_Tr + ") - " + 2 + " *(" +
  console.log("labelA1111", DL, DLR, ES, result["labelA1"]);
  result["txt_A1_NC1"] = A1;
  result["txt_A1_NC1"] = roundToTwo(A1);

  if (TLNP < Outside_Proj_HO) {
    Minimum = TLNP;
  } else if (Outside_Proj_HO < TLNP) {
    Minimum = Outside_Proj_HO;
  }

  console.log("Minimum", Minimum, TLNP, Outside_Proj_HO);
  A2 =
    2 *
    Minimum *
    (Nozzle_Pvd_Thickness_Tn - CAN - Req_Nozzle_Thickness_Trn) *
    FFR2;
  result["labelA2"] =
    "= (" +
    2 +
    " * " +
    roundToTwo(Minimum) +
    ") * (" +
    Nozzle_Pvd_Thickness_Tn +
    " - " +
    CAN +
    " - " +
    roundToTwo(Req_Nozzle_Thickness_Trn) +
    ") * " +
    FFR2;
  result["txt_A2_NC1"] = A2;
  result["txt_A2_NC1"] = roundToTwo(A2);

  A3 = 2 * (Nozzle_Pvd_Thickness_Tn - CAN - CAN) * Minimum * FFR2;
  result["labelA3"] =
    "= " +
    2 +
    " * (" +
    Nozzle_Pvd_Thickness_Tn +
    " - " +
    CAN +
    " - " +
    CAN +
    ") * (" +
    roundToTwo(Minimum) +
    ") * " +
    FFR2;
  result["txt_A3_NC1"] = A3;
  result["txt_A3_NC1"] = roundToTwo(A3);

  A4 =
    Weld_bw_Nozzle_Vessel_WO * Weld_bw_Nozzle_Vessel_WO * FFR2 +
    Nozzle_Weld_Inside_WI * Nozzle_Weld_Inside_WI * FFR2;
  result["labelA4"] =
    "= " +
    Weld_bw_Nozzle_Vessel_WO +
    "^2 * " +
    FFR2 +
    " + (" +
    Nozzle_Weld_Inside_WI +
    " * " +
    Nozzle_Weld_Inside_WI +
    ") * " +
    FFR2;
  result["txt_A4_NC1"] = A4;
  result["txt_A4_NC1"] = roundToTwo(A4);

  Total_Area = A1 + A2 + A3 + A4;
  result["labelTtl"] =
    "= " +
    roundToTwo(A1) +
    " + " +
    roundToTwo(A2) +
    " + " +
    roundToTwo(A3) +
    " + " +
    roundToTwo(A4);
  result["txt_AA_NC1"] = Total_Area;
  result["txt_AA_NC1"] = roundToTwo(Total_Area);

  A5 = Pad_Dia - (DLR + 2 * Nozzle_Pvd_Thickness_Tn) * 0.5 * FFR4;
  result["labelA5"] =
    "= (" +
    Pad_Dia +
    ") - (" +
    DLR +
    " + 2 * " +
    Nozzle_Pvd_Thickness_Tn +
    ") *(0.5)* " +
    FFR4;
  result["txt_A5_NC1"] = A5;
  result["txt_A5_NC1"] = roundToTwo(A5);

  result["Actual_Weld_Size_A"] = roundToTwo(Nozzle_Weld_A * 0.707);
  result["Actual_Weld_Size_B"] = roundToTwo(Inside_Weld_B * 0.707);
  result["Actual_Weld_Size_C"] = roundToTwo(Pad_Weld_C * 0.707);

  console.log("result:", result);
  return result;
};

export const Saddle_Zick_Calc = (input) => {
  var Q_Load_of_Saddle = parseFloat(input.txt_Q_SC) || 0;
  var R_Radius_of_Shell = parseFloat(input.txt_R_SC) || 0;

  var S_Allowable_Stress = parseFloat(input.txt_AS_SC) || 0;

  var L_Length_of_Shell = parseFloat(input.txt_LS_SC) || 0;

  var H_Length_of_Head = parseFloat(input.txt_LH_SC) || 0;

  var A_Saddle_Distance = parseFloat(input.txt_SD_SC) || 0;

  var Ts_Shell_Thickness = parseFloat(input.txt_TS_SC || input.TextBox108) || 0;

  var Th_Head_Thickness = parseFloat(input.txt_TH_SC || input.txt_TR_EHC) || 0;

  var Zero_Contact_Angle = parseFloat(input.txt_CA_SC) || 0;

  var B_Factor = parseFloat(input.TxtBx_Wb_CntrLin) || 0;

  var K1_Value = 0.335;

  var K2_Value = 1.171;

  var K3_Value = 0.319;
  var K4_Value = 0.88;

  var K5_Value = 0.401;

  var K6_Value = 0.036;

  var K7_Value = 0.76;

  var S1_Value;

  var S1a_Value;

  var S2_Value;

  var S2a_Value;

  var S2b_Value;

  var S2c_Value;

  var S3_Value;

  var S4_Value;

  var S4a_Value;

  var S5_Value;

  var result = {};

  console.log(
    R_Radius_of_Shell,
    Q_Load_of_Saddle,
    S_Allowable_Stress,
    L_Length_of_Shell,
    H_Length_of_Head,
    A_Saddle_Distance,
    Ts_Shell_Thickness,
    Th_Head_Thickness,
    B_Factor,
    "rad"
  );

  S1_Value =
    (Q_Load_of_Saddle *
      A_Saddle_Distance *
      (1 -
        (1 -
          A_Saddle_Distance / L_Length_of_Shell +
          (R_Radius_of_Shell * R_Radius_of_Shell -
            H_Length_of_Head * H_Length_of_Head) /
            (2 * A_Saddle_Distance * L_Length_of_Shell)) /
          (1 + (4 * H_Length_of_Head) / (3 * L_Length_of_Shell)))) /
    (K1_Value * R_Radius_of_Shell * R_Radius_of_Shell * Ts_Shell_Thickness);

  console.log("VAleud");
  result["TextBox143"] = roundToTwo(S1_Value, 5);

  S1a_Value =
    (((Q_Load_of_Saddle * L_Length_of_Shell) / 4) *
      ((1 +
        2 *
          ((R_Radius_of_Shell * R_Radius_of_Shell -
            H_Length_of_Head * H_Length_of_Head) /
            (L_Length_of_Shell * L_Length_of_Shell))) /
        (1 + (4 * H_Length_of_Head) / (3 * L_Length_of_Shell)) -
        (4 * A_Saddle_Distance) / L_Length_of_Shell)) /
    (3.14 * R_Radius_of_Shell * R_Radius_of_Shell * Ts_Shell_Thickness);

  result["TextBox144"] = roundToTwo(S1a_Value, 5);

  S2_Value =
    ((K2_Value * Q_Load_of_Saddle) / (R_Radius_of_Shell * Ts_Shell_Thickness)) *
    ((L_Length_of_Shell - 2 * A_Saddle_Distance) /
      (L_Length_of_Shell + (4 * H_Length_of_Head) / 3));

  result["TextBox145"] = roundToTwo(S2_Value, 5);

  S2a_Value =
    ((K3_Value * Q_Load_of_Saddle) / (R_Radius_of_Shell * Ts_Shell_Thickness)) *
    ((L_Length_of_Shell - 2 * A_Saddle_Distance) /
      (L_Length_of_Shell + (4 * H_Length_of_Head) / 3));

  S2b_Value =
    (K4_Value * Q_Load_of_Saddle) / (R_Radius_of_Shell * Ts_Shell_Thickness);

  result["TextBox146"] = roundToTwo(S2b_Value, 5);
  S3_Value =
    (K5_Value * Q_Load_of_Saddle) / (R_Radius_of_Shell * Th_Head_Thickness);
  result["TextBox147"] = roundToTwo(S3_Value, 5);
  S4_Value =
    Q_Load_of_Saddle /
      (4 *
        Ts_Shell_Thickness *
        (B_Factor + 1.56 * Math.sqrt(R_Radius_of_Shell * Ts_Shell_Thickness))) -
    (3 * K6_Value * Q_Load_of_Saddle) /
      (2 * Ts_Shell_Thickness * Ts_Shell_Thickness);
  result["TextBox148"] = roundToTwo(S4_Value, 5);

  S4a_Value =
    Q_Load_of_Saddle /
      (4 *
        Ts_Shell_Thickness *
        (B_Factor + 1.56 * Math.sqrt(R_Radius_of_Shell * Ts_Shell_Thickness))) -
    ((12 * K6_Value * Q_Load_of_Saddle * R_Radius_of_Shell) /
      L_Length_of_Shell) *
      Ts_Shell_Thickness *
      Ts_Shell_Thickness;
  result["TextBox149"] = roundToTwo(S4a_Value, 5);

  S5_Value =
    -(K7_Value * Q_Load_of_Saddle) /
    (Ts_Shell_Thickness * (B_Factor + 1.56 * Math.sqrt(R_Radius_of_Shell)));

  result["TextBox150"] = roundToTwo(S5_Value, 5);

  console.log("saddle", result);
  return result;
};

export const shellEstimation = async (input) => {
  let DataGridView7 = [];
  var tempObject = {};

  if (!input || !Array.isArray(input.DataGridView5)) {
    throw new Error("Invalid input: DataGridView5 is missing or not an array");
  }

  const queryMaker = async (
    selector,
    table,
    colValue,
    rowValue,
    name,
    skip
  ) => {
    let column = "";
    if (skip === true) {
      tempObject[name] = 0;
      return;
    }

    await queryPvDb(`PRAGMA table_info("${table}")`, { type: QueryTypes.SELECT })
      .then((response) => {
        // response[i].name contains the column name
        if (response.length > 0) {
          column = response
            .map((r) => r.name)
            .sort(
              (a, b) =>
                Math.abs(Number(a) - colValue) - Math.abs(Number(b) - colValue)
            )[0];
        }
        console.log(column);
      })
      .catch((err) => {
        console.error(err);
        column = undefined;
      });

    await queryPvDb(
        "SELECT `" +
          column +
          "` FROM `" +
          table +
          "` ORDER BY ABS(`" +
          selector +
          "` - " +
          parseInt(rowValue) +
          ") LIMIT 1",
        { type: QueryTypes.SELECT }
      )
      // await sequelize2.query(`SELECT ${column} FROM ${table} ORDER BY ABS(${selector} - ${rowValue}) LIMIT 1`, { type: QueryTypes.SELECT })
      .then((response) => {
        console.log(response[0]);
        console.log("estimate of name:", response[0][column]);
        tempObject[name] = response[0][column];
      });
  };

  console.log(tempObject);
  for (const [index, row] of input.DataGridView5.entries()) {
    let diameter = (parseFloat(row.Diameter) || 0) / 1000;
    let length = (parseFloat(row["Can Length"]) || 0) / 1000;
    let thickness = parseFloat(row["Provided Thk"] ?? row["Provided Thickness"]) || 0;
    //console.log("--------------------------------------", diameter, length, thickness);

    tempObject["Circ_Weld_Hours"] = 0;
    tempObject["Long_Weld_Hours"] = 0;
    tempObject["Rolling_Hours"] = 0;
    tempObject["Dishing_Hours"] = 0;
    tempObject["NDT_Cost"] = 0;
    //cylindrical shell and conical shell
    if (
      row.Component === "Cylindrical Shell" ||
      row.Component === "Conical Shell"
    ) {
       
      row["Weight"] = roundToTwo(
        3.14 * diameter * length * thickness * 7.85
      );
      await queryMaker(
        "Value",
        "long weld hours",
        thickness,
        row.Diameter,
        "Long_Weld_Hours"
      );
      if (row.Component === "Cylindrical Shell")
        tempObject["Long_Weld_Hours"] = roundToTwo(
          tempObject["Long_Weld_Hours"] * (row["Can Length"] / 1000)
        );
      await queryMaker(
        "Vessel Dia",
        "Shell_Man_Hours",
        thickness,
        row.Diameter,
        "Rolling_Hours"
      );
    }

    //elliptical head
    if (
      row.Component === "2:1 S.E Head (L/B)" ||
      row.Component === "2:1 S.E Head (R/T)"
    ) {
      row["Weight"] = roundToTwo(
        (1.084 * diameter ** 2 + 3.14 * diameter * length) * thickness * 7.85
      );

      await queryMaker(
        "Diameter",
        "circular weld hours",
        thickness,
        row.Diameter,
        "Circ_Weld_Hours"
      );

      await queryMaker(
        "Diameter",
        "head man hours",
        thickness,
        row.Diameter,
        "Dishing_Hours"
      );
    }
    DataGridView7.push({ ...tempObject });
  }
  console.log("The inptu dgv: ", input.DataGridView5);
  return [input.DataGridView5, DataGridView7];
};

export const nozzleEstimation = async (input) => {
  let DataGridView2 = [];
  var tempObject = {};

  // "Flange Weight",
  // "Pipe Weight",
  // "Pad Weight",
  // "Nozzle Man-Hours",
  // "Bolt-up Hours",
  // "Long Weld",
  // "Circ Weld",
  // "NDT Cost"

  // Create an array of Promises for each query
  const promises = input["DataGridView1"].map(async (elem, index) => {
    const PadWeightPromise = await queryPvDb(
        'SELECT `Weight` FROM `Pad Weight` WHERE `Size` = "' +
          elem["Size"] +
          '" AND `Sch` = "Sch. ' +
          elem["Sch/Thk"] +
          '"',
        { type: QueryTypes.SELECT }
      )
      .then((response) => {
        tempObject["Pad Weight"] = response.length
          ? response[0]["Weight"]
          : null;
      });

    console.log("tempObject", tempObject);
    const PipeWeightPromise = queryPvDb(
        'select `Weight` from `Pipe Weight` where Size = "' +
          elem["Size"] +
          '" and `Sch` = "Sch. ' +
          elem["Sch/Thk"] +
          '" LIMIT 1',
        { type: QueryTypes.SELECT }
      )
      .then((response) => {
        tempObject["Pipe Weight"] = response.length
          ? response[0]["Weight"]
          : null;
      });

    console.log("tempObject", tempObject);
    const FlangeWeightPromise = queryPvDb(
        'select `Weight` from `Flange Weight` where Size = "' +
          elem["Size"] +
          '" and `Sch` = "Sch. ' +
          elem["Sch/Thk"] +
          '" LIMIT 1',
        { type: QueryTypes.SELECT }
      )
      .then((response) => {
        tempObject["Flange Weight"] = response.length
          ? response[0]["Weight"]
          : null;
      });
    console.log("tempObject", tempObject);

    // const nozzleMDMTPromise = sequelize2.query('select `MDMT Curve 1` from `MDMT Curve 1` where Material = "' + elem["Nozzle Material"] + '" LIMIT 1', { type: QueryTypes.SELECT })
    //     .then(response => {
    //         materials[index]["Nozzle MDMT Curve"] = response[0]["MDMT Curve 1"];
    //     });

    // const padMDMTPromise = sequelize2.query('select `MDMT Curve 1` from `MDMT Curve 1` where Material = "' + elem["Pad Material"] + '" LIMIT 1', { type: QueryTypes.SELECT })
    //     .then(response => {
    //         materials[index]["Pad MDMT Curve"] = response[0]["MDMT Curve 1"];
    //     });

    // const flangeMDMTPromise = sequelize2.query('select `MDMT Curve 1` from `MDMT Curve 1` where Material = "' + elem["Flange Material"] + '" LIMIT 1', { type: QueryTypes.SELECT })
    //     .then(response => {
    //         materials[index]["Flange MDMT Curve"] = response[0]["MDMT Curve 1"];
    //     });

    // Wait for all Promises to resolve using Promise.all()
    await Promise.all([
      PadWeightPromise,
      PipeWeightPromise,
      FlangeWeightPromise,
    ]);
    // await Promise.all([PadWeightPromise]);
    DataGridView2.push(tempObject);
    console.log("DataGridView2", DataGridView2);
  });

  // Wait for all Promises in the array to resolve
  await Promise.all(promises)
    .then((response) => {
      console.log("resp", DataGridView2);
      // res.status(200).send(DataGridView2)
    })
    .catch((error) => {
      console.log("An error occurred while running the queries:", error);
    });

  // res = await sequelize2.query('SELECT `Weight` FROM `Pad Weight` WHERE `Size` = "' + elem["Size"] + '" AND `Sch` = "Sch. ' + elem["Sch/Thk"] + '"', { type: QueryTypes.SELECT })
  //         .then(response => {
  //             console.log("response", response);
  //             // tempObject["Pad Weight"] = response[0]["Weight"]
  //         });

  return DataGridView2;
};

export const Wind_Load = (input) => {
  var Inside_Diameter_Di = parseFloat(input.D_Diameter_WL) || 0;
  var Diameter_D = parseFloat(input.D1_Diameter_WL) || 0;
  var E_Joint_Efficiency = parseFloat(input.E_Joint_Efficiency_WL) || 0.85;
  var H_Height = parseFloat(input.H_Height_WL) || 0;
  var HT_Height = parseFloat(input.HT_Height_WL) || 0;
  var P_Pressure = parseFloat(input.P_Pressure_WL) || 0;
  var PW_Pressure = parseFloat(input.PW_Pressure_WL) || 0;
  var S_Allowable_Stress = parseFloat(input.S_Allowable_Stress_WL) || 0;

  var R_Radius = Inside_Diameter_Di / 2;

  var result = {};

  var t_req_thickness = (P_Pressure * (Inside_Diameter_Di / 2)) / (S_Allowable_Stress * E_Joint_Efficiency - 0.6 * P_Pressure);
  result["t_req_thickness_WL"] = roundToTwo(t_req_thickness);

  var t_req_thickness_1 = (P_Pressure * (Inside_Diameter_Di / 2)) / (2 * S_Allowable_Stress * E_Joint_Efficiency + 0.4 * P_Pressure);
  result["t_req_thickness_1_WL"] = roundToTwo(t_req_thickness_1);

  var H1_Height = H_Height / 2;
  result["H1_Height_WL"] = roundToTwo(H1_Height);

  var V_Total_Shear = PW_Pressure * Diameter_D * H_Height;
  result["V_Total_Shear_WL"] = roundToTwo(V_Total_Shear);

  var M_Moment = V_Total_Shear * H1_Height;
  result["M_Moment_WL"] = roundToTwo(M_Moment);

  var Mt_Moment_Bottom = (M_Moment - HT_Height * (V_Total_Shear - 0.5 * PW_Pressure * Diameter_D * HT_Height)) * 12;
  result["Mt_Moment_Bottom_WL"] = roundToTwo(Mt_Moment_Bottom);

  var T_Required_Thickness = Mt_Moment_Bottom / (R_Radius * R_Radius * 3.14 * S_Allowable_Stress * E_Joint_Efficiency);
  result["T_Required_Thickness_WL"] = roundToTwo(T_Required_Thickness);

  var Total_Thickness = T_Required_Thickness + t_req_thickness_1;
  result["Total_Thickness_WL"] = roundToTwo(Total_Thickness);

  return result;
};

export const Seismic_Load = (input) => {
  var Z_Seismic_zone_factor = parseFloat(input.Z_Seismic_zone_factor_SL) || 0;
  var D_Diameter = parseFloat(input.D_Diameter_SL) || 0;
  var X_Distance = parseFloat(input.X_Distance_SL) || 0;
  var H_Length = parseFloat(input.H_Length_SL) || 0;
  var W_Weight = parseFloat(input.W_Weight_SL) || 0;
  var Ct_Numerical_Coefficient = parseFloat(input.Ct_Numerical_Coefficient_SL) || 0.035;
  var I_importance_coefficient = parseFloat(input.I_importance_coefficient_SL) || 1;
  var S_Site_Coefficient = parseFloat(input.S_Site_Coefficient_SL) || 1.5;
  var RW_Numerical_Coefficient = parseFloat(input.RW_Numerical_Coefficient_SL) || 2.9;

  var result = {};

  var T_Vibration = Ct_Numerical_Coefficient * Math.pow(H_Length, 3 / 4);
  result["T_Vibration_SL"] = roundToTwo(T_Vibration);

  var C_Numerical_Coefficient = (1.25 * S_Site_Coefficient) / Math.pow(T_Vibration, 2 / 3);
  result["C_Numerical_Coefficient_SL"] = roundToTwo(C_Numerical_Coefficient);

  var V_Seismic_Shear = (Z_Seismic_zone_factor * I_importance_coefficient * C_Numerical_Coefficient * W_Weight) / RW_Numerical_Coefficient;
  result["V_Seismic_Shear_SL"] = roundToTwo(V_Seismic_Shear);

  var Ft_Hor_Seismic_Force = 0.07 * T_Vibration * V_Seismic_Shear;
  result["Ft_Hor_Seismic_Force_SL"] = roundToTwo(Ft_Hor_Seismic_Force);

  var M_Moment = Ft_Hor_Seismic_Force * H_Length + (V_Seismic_Shear - Ft_Hor_Seismic_Force) * ((2 * H_Length) / 3);
  result["M_Moment_SL"] = roundToTwo(M_Moment);

  return result;
};

export const Deflection = (input) => {
  var D1_Diameter = parseFloat(input.D1_Diameter_Df) || 0;
  var E_modulus_of_elasticity = parseFloat(input.E_modulus_of_elasticity_Df) || 0;
  var H_Length = parseFloat(input.H_Length_Df) || 0;
  var Pw_Wind_Pressure = parseFloat(input.PW_Pressure_Df) || 0;
  var R_Mean_Radius = parseFloat(input.R_Mean_Radius_Df) || 0;
  var T_Thickness = parseFloat(input.T_Thickness_Df) || 0;

  var result = {};

  var M_Maximum_Deflection = (Pw_Wind_Pressure * D1_Diameter * H_Length * Math.pow(12 * H_Length, 3)) / (8 * E_modulus_of_elasticity * Math.pow(R_Mean_Radius, 3) * 3.14 * T_Thickness);
  result["M_Maximum_Deflection_Df"] = roundToTwo(M_Maximum_Deflection);

  return result;
};

export const Skirt_Support = (input) => {
  var D_Diameter = parseFloat(input.D_Diameter_SS) || 0;
  var S_Allowable_Stress = parseFloat(input.S_Allowable_Stress_SS) || 0;
  var E_Joint_Efficiency = parseFloat(input.E_Joint_Efficiency_SS) || 0;
  var Mt_Moment_Bottom = parseFloat(input.Mt_Moment_Bottom_SS) || 0;
  var W_Weight = parseFloat(input.W_Weight_SS) || 0;

  var R_Radius = D_Diameter / 2;

  var result = {};

  var T_Thickness_Wind = (12 * Mt_Moment_Bottom) / (R_Radius * R_Radius * 3.14 * S_Allowable_Stress * E_Joint_Efficiency);
  result["T_Thickness_Wind_SS"] = roundToTwo(T_Thickness_Wind, 5);

  var T_Thickness_Weight = W_Weight / (D_Diameter * 3.14 * S_Allowable_Stress * E_Joint_Efficiency);
  result["T_Thickness_Weight_SS"] = roundToTwo(T_Thickness_Weight, 5);

  var Total_Thickness = T_Thickness_Wind + T_Thickness_Weight;
  result["Total_Thickness_SS"] = roundToTwo(Total_Thickness, 5);

  return result;
};

export const Anchor_Bolt = (input) => {
  var D_Bolt_Dia = parseFloat(input.D_Bolt_Dia_AB) || 0;
  var R_Radius = parseFloat(input.R_Radius_AB) || 0;
  var Ab_Area_of_Bolt = parseFloat(input.Ab_Area_of_Bolt_AB) || 0;
  var Cb_Circumference = parseFloat(input.Cb_Circumference_AB) || 0;
  var M_Moment = parseFloat(input.M_Moment_AB) || 0;
  var W_Weight = parseFloat(input.W_Weight_AB) || 0;
  var S_Allowable_Stress = parseFloat(input.S_Allowable_Stress_AB) || 0;
  var N_No_of_Holes = parseFloat(input.N_No_of_Holes_AB) || 0;

  var result = {};

  var T_Maximum_tension = (12 * M_Moment) / Ab_Area_of_Bolt - W_Weight / Cb_Circumference;
  result["T_Maximum_tension_AB"] = roundToTwo(T_Maximum_tension);

  var Ba_Area_of_Bolt = (T_Maximum_tension * Cb_Circumference) / (S_Allowable_Stress * N_No_of_Holes);
  result["Ba_Area_of_Bolt_AB"] = roundToTwo(Ba_Area_of_Bolt);

  var Sb_Stress_in_Anchor_Bolt = (T_Maximum_tension * Cb_Circumference) / (2.3 * 4);
  result["Sb_Stress_in_Anchor_Bolt_AB"] = roundToTwo(Sb_Stress_in_Anchor_Bolt);

  return result;
};

export const Base_Ring = (input) => {
  var M_Moment = parseFloat(input.M_Moment_BR) || 0;
  var Fb_Safe_Bearing = parseFloat(input.Fb_Safe_Bearing_BR) || 0;
  var D_Dia_of_Skirt = parseFloat(input.D_Dia_of_Skirt_BR) || 0;
  var R_Radius = parseFloat(input.R_Radius_BR) || 0;
  var Ab_Area_of_Bolt = parseFloat(input.Ab_Area_of_Bolt_BR) || 0;
  var Cb_Circumference = parseFloat(input.Cb_Circumference_BR) || 0;
  var W_Weight = parseFloat(input.W_Weight_BR) || 0;

  var result = {};

  var Pc_Max_Compression = (12 * M_Moment) / Ab_Area_of_Bolt - W_Weight / Cb_Circumference;
  result["Pc_Max_Compression_BR"] = roundToTwo(Pc_Max_Compression);

  var L_width_Base_Ring = Pc_Max_Compression / Fb_Safe_Bearing;
  result["L_width_Base_Ring_BR"] = roundToTwo(L_width_Base_Ring);

  var Tb_Thickness_Base_Ring = 0.32 * L_width_Base_Ring;
  result["Tb_Thickness_Base_Ring_BR"] = roundToTwo(Tb_Thickness_Base_Ring);

  var S1_Bearing_Stress = (Pc_Max_Compression * Cb_Circumference) / 574;
  result["S1_Bearing_Stress_BR"] = roundToTwo(S1_Bearing_Stress);

  var S2_Bearing_Stress_2 = (3 * S1_Bearing_Stress * L_width_Base_Ring * L_width_Base_Ring) / (Tb_Thickness_Base_Ring * Tb_Thickness_Base_Ring);
  result["S2_Bearing_Stress_2_BR"] = roundToTwo(S2_Bearing_Stress_2);

  return result;
};

export const Combination_of_Stress = (input) => {
  var Tp_Req_Thickness = 0.233;

  var Tw_Thickness_for_Wind_Pressure = 0.644;

  var Tw_Tp = Tw_Thickness_for_Wind_Pressure / Tp_Req_Thickness;

  var H_Height = 1200;

  var m;

  var X;

  if (Tw_Tp === 0.5) {
    m = 1;
  } else if (Tw_Tp === 0.6) {
    m = 0.91;
  } else if (Tw_Tp === 0.7) {
    m = 0.84;
  } else if (Tw_Tp === 0.8) {
    m = 0.79;
  } else if (Tw_Tp === 0.9) {
    m = 0.74;
  } else if (Tw_Tp === 1.0) {
    m = 0.71;
  } else if (Tw_Tp === 1.1) {
    m = 0.67;
  } else if (Tw_Tp === 1.2) {
    m = 0.64;
  } else if (Tw_Tp === 1.3) {
    m = 0.62;
  } else if (Tw_Tp === 1.4) {
    m = 0.6;
  } else if (Tw_Tp === 1.5) {
    m = 0.58;
  } else if (Tw_Tp === 1.6) {
    m = 0.56;
  } else if (Tw_Tp === 1.7) {
    m = 0.54;
  } else if (Tw_Tp === 1.8) {
    m = 0.53;
  } else if (Tw_Tp === 1.9) {
    m = 0.51;
  } else if (Tw_Tp === 2.0) {
    m = 0.5;
  } else if (Tw_Tp === 2.2) {
    m = 0.48;
  } else if (Tw_Tp === 2.4) {
    m = 0.46;
  } else if (Tw_Tp === 2.6) {
    m = 0.44;
  } else if (Tw_Tp === 2.8) {
    m = 0.42;
  } else if (Tw_Tp === 3.0) {
    m = 0.41;
  } else if (Tw_Tp === 3.3) {
    m = 0.39;
  } else if (Tw_Tp === 3.6) {
    m = 0.37;
  } else if (Tw_Tp === 4.0) {
    m = 0.35;
  } else if (Tw_Tp === 4.5) {
    m = 0.33;
  } else if (Tw_Tp === 5.0) {
    m = 0.32;
  }

  X = m * H_Height;
};

export const Torispherical_Head_Calc = (input) => {
  var Design_Pressure = parseFloat(input.txt_DP_THC) || 0;
  var Allowable_Stress = parseFloat(input.txt_AS_THC) || 0;
  var Joint_Efficiency = parseFloat(input.txt_JE_THC) || 0;
  var Provided_Thickness = parseFloat(input.txt_PT_THC) || 0;
  var Corrosion_Allowance = parseFloat(input.txt_CA_THC) || 0;
  var Inside_Diameter = parseFloat(input.txt_ID_THC) || 0;
  var Crown_Radius = parseFloat(input.txt_CR_THC) || 0;
  var Knurkle_Radius = parseFloat(input.txt_KR_THC) || 0;
  var Straight_Flange = parseFloat(input.txt_SF_THC) || 0;
  var CAE = 0;

  var Density = parseFloat(input.TextBox30) / 10 ** 9 || 0;
  var Gravity = 9.81;
  var Height = parseFloat(input.TextBox66) * 1000 || 0;
  var Hydrostatic_Head_Pressure = 0.02;

  var Liquid_Head = Density * Gravity * Height;
  var Design_Pressure_New = Design_Pressure + Liquid_Head;

  var result = {};
  result["txt_LH_THC"] = roundToTwo(Liquid_Head);

  var Do_t_Ratio = Crown_Radius / Provided_Thickness;
  result["TextBox83"] = roundToTwo(Do_t_Ratio);

  var B_Factor = parseFloat(input.txt_BF_THC) || 0;
  var Max_Allowable_Stress_Pa = B_Factor / (Crown_Radius / Provided_Thickness);
  result["TextBox212"] = roundToTwo(Max_Allowable_Stress_Pa);

  var M_Factor = (3 + Math.sqrt((Crown_Radius + Corrosion_Allowance) / (Knurkle_Radius + Corrosion_Allowance))) / 4;
  result["TextBox125"] = roundToTwo(M_Factor);

  var M_Factor_NC = (3 + Math.sqrt(Crown_Radius / Knurkle_Radius)) / 4;
  result["TextBox127"] = roundToTwo(M_Factor_NC);

  if (input.ComboBox7 === "ID") {
    result["Label595"] = "Inside Diameter";
    var Req_Head_Thickness = (Design_Pressure_New * (Crown_Radius + Corrosion_Allowance) * M_Factor) / (2 * Allowable_Stress * Joint_Efficiency - 0.2 * Design_Pressure_New);
    var MAWP_Max_Working_Pressure = (2 * Allowable_Stress * Joint_Efficiency * (Provided_Thickness - Corrosion_Allowance)) / (M_Factor * (Crown_Radius + Corrosion_Allowance) + 0.2 * (Provided_Thickness - Corrosion_Allowance)) - Hydrostatic_Head_Pressure;
    var MAPNC_Max_Pressure_NC = (2 * Allowable_Stress * Joint_Efficiency * Provided_Thickness) / (M_Factor_NC * Crown_Radius + 0.2 * Provided_Thickness);
  } else {
    result["Label595"] = "Outside Diameter";
    var Req_Head_Thickness = (Design_Pressure_New * (Crown_Radius + Provided_Thickness) * M_Factor) / (2 * Allowable_Stress * Joint_Efficiency - Design_Pressure_New * (M_Factor - 0.2));
    var MAWP_Max_Working_Pressure = (2 * Allowable_Stress * Joint_Efficiency * (Provided_Thickness - Corrosion_Allowance)) / (M_Factor * (Crown_Radius + Provided_Thickness) - (Provided_Thickness - Corrosion_Allowance) * (M_Factor - 0.2)) - Hydrostatic_Head_Pressure;
    var MAPNC_Max_Pressure_NC = (2 * Allowable_Stress * Joint_Efficiency * Provided_Thickness) / (M_Factor_NC * (Crown_Radius + Provided_Thickness) - Provided_Thickness * (M_Factor_NC - 0.2));
  }

  result["TextBox112"] = roundToTwo(Req_Head_Thickness + Corrosion_Allowance);
  result["TextBox126"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["TextBox128"] = roundToTwo(MAPNC_Max_Pressure_NC);
  result["TextBox129"] = roundToTwo(Req_Head_Thickness + Corrosion_Allowance);
  result["TextBox196"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["TextBox197"] = roundToTwo(MAPNC_Max_Pressure_NC);
  result["TextBox198"] = roundToTwo(MAWP_Max_Working_Pressure * 1.3);
  result["TextBox199"] = roundToTwo(MAPNC_Max_Pressure_NC * 1.3 - Liquid_Head);
  result["TextBox200"] = 6.96;
  result["TextBox201"] = 0;

  return result;
};

export const Sphere_Hemispherical_Head_Calc = (input) => {
  var Design_Pressure = parseFloat(input.txt_DP_SHC) || 0;
  var Allowable_Stress = parseFloat(input.txt_AS_SHC) || 0;
  var Joint_Efficiency = parseFloat(input.txt_JE_SHC) || 0;
  var Diameter = parseFloat(input.txt_ID_SHC) || 0;
  var Provided_Thickness = parseFloat(input.txt_PT_SHC) || 0;
  var Corrosion_Allowance = parseFloat(input.txt_CA_SHC) || 0;
  var CAE = 0;
  var B_Factor = parseFloat(input.txt_BF_SHC) || 0;

  var Density = parseFloat(input.TextBox30) / 10 ** 9 || 0;
  var Gravity = 9.81;
  var Height = parseFloat(input.TextBox66) * 1000 || 0;
  var Hydrostatic_Head_Pressure = 0.02;

  var Liquid_Head = Density * Gravity * Height;
  var Design_Pressure_New = Design_Pressure + Liquid_Head;

  var result = {};
  result["txt_LH_SHC"] = roundToTwo(Liquid_Head);

  var Do_t_Ratio = Diameter / Provided_Thickness;
  result["TextBox65"] = roundToTwo(Do_t_Ratio);

  var Max_Allowable_Stress_Pa = B_Factor / (Do_t_Ratio / 2);
  result["TextBox77"] = roundToTwo(Max_Allowable_Stress_Pa);

  var Req_Shell_Thickness, MAWP_Max_Working_Pressure, MAPNC_Max_Pressure_NC;

  if (input.ComboBox7 === "ID") {
    result["Label404"] = "Inside Diameter";
    Req_Shell_Thickness = (Design_Pressure_New * (Diameter / 2 + Corrosion_Allowance)) / (2 * Allowable_Stress * Joint_Efficiency - 0.2 * Design_Pressure_New);
    MAWP_Max_Working_Pressure = (2 * Allowable_Stress * Joint_Efficiency * (Provided_Thickness - Corrosion_Allowance - CAE)) / ((Diameter / 2 + Corrosion_Allowance) + 0.2 * (Provided_Thickness - Corrosion_Allowance - CAE)) - Hydrostatic_Head_Pressure;
    MAPNC_Max_Pressure_NC = (2 * Allowable_Stress * Joint_Efficiency * (Provided_Thickness - CAE)) / (Diameter / 2 + 0.2 * (Provided_Thickness - CAE));
  } else {
    result["Label404"] = "Outside Diameter";
    Req_Shell_Thickness = (Design_Pressure_New * (Diameter / 2)) / (2 * Allowable_Stress * Joint_Efficiency + 0.8 * Design_Pressure_New);
    MAWP_Max_Working_Pressure = (2 * Allowable_Stress * Joint_Efficiency * (Provided_Thickness - Corrosion_Allowance - CAE)) / ((Diameter / 2 + Corrosion_Allowance) - 0.8 * (Provided_Thickness - Corrosion_Allowance - CAE)) - Hydrostatic_Head_Pressure;
    MAPNC_Max_Pressure_NC = (2 * Allowable_Stress * Joint_Efficiency * (Provided_Thickness - CAE)) / (Diameter / 2 - 0.8 * (Provided_Thickness - CAE));
  }

  result["TextBox186"] = roundToTwo(Req_Shell_Thickness + Corrosion_Allowance);
  result["TextBox187"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["TextBox188"] = roundToTwo(MAPNC_Max_Pressure_NC);
  result["TextBox189"] = roundToTwo(Req_Shell_Thickness + Corrosion_Allowance);
  result["TextBox190"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["TextBox191"] = roundToTwo(MAPNC_Max_Pressure_NC);
  result["TextBox192"] = roundToTwo(MAWP_Max_Working_Pressure * 1.3);
  result["TextBox193"] = roundToTwo(MAPNC_Max_Pressure_NC * 1.3);
  result["TextBox194"] = 0.487;
  result["TextBox195"] = -20;

  return result;
};

export const Flat_Head_Calc = (input) => {
  var Design_Pressure = parseFloat(input.txt_DP_FHC) || 0;
  var Allowable_Stress = parseFloat(input.txt_AS_FHC) || 0;
  var Joint_Efficiency = parseFloat(input.txt_JE_FHC) || 0;
  var Provided_Thickness = parseFloat(input.txt_PT_FHC) || 0;
  var Corrosion_Allowance = parseFloat(input.txt_CA_FHC) || 0;
  var Attachment_Factor_C = parseFloat(input.txt_CF_FHC) || 0;
  var Large_Diameter = parseFloat(input.txt_DL_FHC) || 0;
  var Diameter = parseFloat(input.txt_ID_FHC) || 0;

  var Density = parseFloat(input.TextBox30) / 10 ** 9 || 0;
  var Gravity = 9.81;
  var Height = parseFloat(input.TextBox66) * 1000 || 0;
  var Hydrostatic_Head_Pressure = 0.02;

  var Liquid_Head = Density * Gravity * Height;
  var Design_Pressure_New = Design_Pressure + Liquid_Head;

  var result = {};
  result["txt_LH_FHC"] = roundToTwo(Liquid_Head);

  var Req_Head_Thickness = Diameter * Math.sqrt((Attachment_Factor_C * Design_Pressure_New) / (Allowable_Stress * Joint_Efficiency));
  result["TextBox202"] = roundToTwo(Req_Head_Thickness);

  var MAWP_Max_Working_Pressure = Math.pow((Provided_Thickness - Corrosion_Allowance) / Diameter, 2) * (Allowable_Stress * Joint_Efficiency / Attachment_Factor_C) - Hydrostatic_Head_Pressure;
  result["TextBox203"] = roundToTwo(MAWP_Max_Working_Pressure);

  var MAPNC_Max_Pressure_NC = Math.pow(Provided_Thickness / Diameter, 2) * (Allowable_Stress * Joint_Efficiency / Attachment_Factor_C);
  result["TextBox204"] = roundToTwo(MAPNC_Max_Pressure_NC);

  result["TextBox205"] = roundToTwo(Req_Head_Thickness + Corrosion_Allowance);
  result["TextBox206"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["TextBox207"] = roundToTwo(MAPNC_Max_Pressure_NC);
  result["TextBox208"] = roundToTwo(MAWP_Max_Working_Pressure * 1.3);
  result["TextBox209"] = roundToTwo(1.3 * MAPNC_Max_Pressure_NC - Liquid_Head);
  result["TextBox210"] = 0.997;
  result["TextBox211"] = -46;

  return result;
};

export const Conical_Shell_Calc = (input) => {
  var Design_Pressure = parseFloat(input.txt_DP_COSC) || 0;
  var Allowable_Stress = parseFloat(input.txt_AS_COSC) || 0;
  var Joint_Efficiency = parseFloat(input.txt_JE_COSC) || 0;
  var Provided_Thickness = parseFloat(input.txt_PT_COSC) || 0;
  var Corrosion_Allowance = parseFloat(input.txt_CA_COSC) || 0;
  var Small_Diameter = parseFloat(input.txt_DSE_COSC) || 0;
  var Large_Diameter = parseFloat(input.txt_DLE_COSC) || 0;
  var Half_Apex_Angle = parseFloat(input.txt_\u03B1_COSC) || 0;
  var Cone_Length = parseFloat(input.txt_LC_COSC) || 0;
  var CAE = 0;
  var B_Factor = parseFloat(input.txt_BF_COSC) || 0;

  var result = {};

  var Te_Eff_Thickness = Provided_Thickness * Math.cos(Half_Apex_Angle * Math.PI / 180);
  var Le_Eff_Length = (Cone_Length / 2) * (1 + Small_Diameter / Large_Diameter);
  result["TextBox47"] = roundToTwo(Le_Eff_Length);

  var Le_Dl_Ratio = Le_Eff_Length / Large_Diameter;
  result["TextBox53"] = roundToTwo(Le_Dl_Ratio);

  var Dl_Te_Ratio = Large_Diameter / Te_Eff_Thickness;
  result["TextBox54"] = roundToTwo(Dl_Te_Ratio);

  var Pa_Max_Work_Pressure = (4 * B_Factor) / (3 * (Large_Diameter / Te_Eff_Thickness));
  result["TextBox87"] = roundToTwo(Pa_Max_Work_Pressure);

  var cosA = Math.cos(Half_Apex_Angle * Math.PI / 180);
  var Req_Cone_Thickness, MAWP_Max_Working_Pressure;

  if (input.ComboBox7 === "OD") {
    Req_Cone_Thickness = (Design_Pressure * (Large_Diameter - 2 * (CAE / cosA))) / (2 * cosA * (Allowable_Stress * Joint_Efficiency + 0.4 * Design_Pressure));
    MAWP_Max_Working_Pressure = (2 * Allowable_Stress * Joint_Efficiency * (Provided_Thickness - Corrosion_Allowance) * cosA) / (Large_Diameter - 2 * (CAE / cosA)) - 0.8 * (Provided_Thickness - Corrosion_Allowance) * cosA;
  } else {
    Req_Cone_Thickness = (Design_Pressure * (Large_Diameter + 2 * (Corrosion_Allowance / cosA))) / (2 * cosA * (Allowable_Stress * Joint_Efficiency - 0.6 * Design_Pressure));
    MAWP_Max_Working_Pressure = (2 * Allowable_Stress * Joint_Efficiency * (Provided_Thickness - Corrosion_Allowance) * cosA) / (Large_Diameter + 2 * (Corrosion_Allowance / cosA)) + 1.2 * (Provided_Thickness - Corrosion_Allowance) * cosA;
  }

  result["TextBox84"] = roundToTwo(Req_Cone_Thickness + Corrosion_Allowance);
  result["TextBox110"] = roundToTwo(Req_Cone_Thickness + Corrosion_Allowance);
  result["TextBox109"] = roundToTwo(MAWP_Max_Working_Pressure);
  result["TextBox111"] = roundToTwo(MAWP_Max_Working_Pressure);

  return result;
};

export const Stress_Moment_Calc = (input) => {
  var Contact_Angle = parseFloat(input.txt_SMC_CA) || 0;
  var L1 = parseFloat(input.txt_SMC_L1) || 0;
  var W1 = parseFloat(input.txt_SMC_W1) || 0;
  var L2 = parseFloat(input.txt_SMC_L2) || 0;
  var W2 = parseFloat(input.txt_SMC_W2) || 0;

  var K9 = 6.35, K10 = 0.4318;
  var angleMap = { 120: [8.636, 1.3462], 130: [8.382, 1.143], 140: [8.128, 0.9398], 150: [7.62, 0.8128], 160: [7.366, 0.6604], 170: [6.858, 0.5588], 180: [6.35, 0.4318] };
  if (angleMap[Contact_Angle]) { K9 = angleMap[Contact_Angle][0]; K10 = angleMap[Contact_Angle][1]; }

  var result = {};

  var Area_of_Rectangle_A1 = L1 * W1;
  result["txt_SMC_A1"] = roundToTwo(Area_of_Rectangle_A1);

  var Area_of_Rectangle_A2 = L2 * W2;
  result["txt_SMC_A2"] = roundToTwo(Area_of_Rectangle_A2);

  var Total_Area = Area_of_Rectangle_A1 + Area_of_Rectangle_A2;
  result["txt_SMC_TA"] = roundToTwo(Total_Area);

  var Distance_Y1 = W1 / 2;
  result["txt_SMC_Y1"] = roundToTwo(Distance_Y1);

  var Distance_Y2 = W2 / 2 + 0.5;
  result["txt_SMC_Y2"] = roundToTwo(Distance_Y2);

  var Area_Distance1 = Distance_Y1 * Area_of_Rectangle_A1;
  result["txt_SMC_AD1"] = roundToTwo(Area_Distance1);

  var Area_Distance2 = Distance_Y2 * Area_of_Rectangle_A2;
  result["txt_SMC_AD2"] = roundToTwo(Area_Distance2);

  var Total_Distance = Area_Distance1 + Area_Distance2;
  result["txt_SMC_TAD"] = roundToTwo(Total_Distance);

  var IG1 = L1 * Math.pow(W1, 3) / 12;
  result["txt_SMC_IG1"] = roundToTwo(IG1);

  var IG2 = L2 * Math.pow(W2, 3) / 12;
  result["txt_SMC_IG2"] = roundToTwo(IG2);

  var IG = IG1 + IG2;
  result["txt_SMC_IG"] = roundToTwo(IG);

  var Value_C = Total_Distance / Total_Area;
  result["txt_SMC_C"] = roundToTwo(Value_C);

  var h1 = Area_Distance1;
  var h2 = 51.308;
  var h_Square_1 = h1 * h1;
  var h_Square_2 = h2 * h2;
  var a_h_square_1 = Area_of_Rectangle_A1 * h_Square_1;
  var a_h_square_2 = Area_of_Rectangle_A2 * h_Square_2;
  var a_h_square = a_h_square_1 + a_h_square_2;

  var I = a_h_square + IG;
  result["txt_SMC_I"] = roundToTwo(I);

  return result;
};

export const Leg_Support_Calc = (input) => {
  var W_Weight = parseFloat(input.W_Weight_of_vessel_pounds_Leg) || 0;
  var n_number_of_legs = parseFloat(input.n_number_of_legs_Leg) || 1;
  var Q_Load_on_One_Leg = W_Weight / n_number_of_legs;
  var R_Radius_of_Head = parseFloat(input.R_Radius_of_Head_Leg) || 0;
  var H_Lever_arm_of_Load = parseFloat(input.H_Lever_arm_of_Load_Leg) || 0;
  var wear_plate_2A = parseFloat(input.Dim_wear_plate_2A_Leg) || 0;
  var wear_plate_A = wear_plate_2A / 2;
  var wear_plate_2B = parseFloat(input.Dim_wear_plate_2B_Leg) || 0;
  var wear_plate_B = wear_plate_2B / 2;
  var S_Stress = parseFloat(input.S_Stress_Leg) || 0;
  var P_Design_Pressure = parseFloat(input.P_Design_Pressure_Leg) || 0;
  var E_Joint_Efficiency = parseFloat(input.E_Joint_Efficiency_Leg) || 0;
  var t_wall_thickness = parseFloat(input.t_wall_thickness_Leg) || 0;

  var K1 = 0.065, K2 = 0.03, K3 = 0.065, K4 = 0.025, K5 = 0.02, K6 = 0.01, K7 = 0.022, K8 = 0.01, cos_value = 0.8;

  var result = {};
  result["Q_Load_on_One_Leg_Leg"] = roundToTwo(Q_Load_on_One_Leg);

  var C_Radius = Math.sqrt(wear_plate_A * wear_plate_B);
  result["C_Radius_of_circular_wear_plate_Leg"] = roundToTwo(C_Radius);

  var D_Value = (1.82 * C_Radius / R_Radius_of_Head) * Math.sqrt(R_Radius_of_Head / t_wall_thickness);
  result["D_Value_Leg"] = roundToTwo(D_Value);

  var S1_Long = (Q_Load_on_One_Leg / (t_wall_thickness * t_wall_thickness)) * (cos_value * (-K1 + 6 * K2) + (H_Lever_arm_of_Load / R_Radius_of_Head) * Math.sqrt(R_Radius_of_Head / t_wall_thickness) * (-K3 + 6 * K4));
  result["S1_Maximum_tensile_stress_Long_Leg"] = roundToTwo(S1_Long);

  var Stress = (P_Design_Pressure * R_Radius_of_Head) / (2 * t_wall_thickness);
  result["Stress_Leg"] = roundToTwo(Stress);

  result["Sum_of_Stress1_Leg"] = roundToTwo(S1_Long + Stress);

  var SC1_Long = (Q_Load_on_One_Leg / (t_wall_thickness * t_wall_thickness)) * (cos_value * (-K1 - 6 * K2) + (H_Lever_arm_of_Load / R_Radius_of_Head) * Math.sqrt(R_Radius_of_Head / t_wall_thickness) * (-K3 - 6 * K4));
  result["S1_Maximum_compressional_stress_Long_Leg"] = roundToTwo(SC1_Long);

  result["Sum_of_Stress2_Leg"] = roundToTwo(SC1_Long + Stress);

  var S2_Cir = (Q_Load_on_One_Leg / (t_wall_thickness * t_wall_thickness)) * (cos_value * (-K5 + 6 * K6) + (H_Lever_arm_of_Load / R_Radius_of_Head) * Math.sqrt(R_Radius_of_Head / t_wall_thickness) * (-K7 + 6 * K8));
  result["S2_Maximum_tensile_stress_Cir_Leg"] = roundToTwo(S2_Cir);

  result["Sum_of_Stress3_Leg"] = roundToTwo(-(S2_Cir + Stress));

  var SL2_Cir = (Q_Load_on_One_Leg / (t_wall_thickness * t_wall_thickness)) * (cos_value * (-K5 - 6 * K6) + (H_Lever_arm_of_Load / R_Radius_of_Head) * Math.sqrt(R_Radius_of_Head / t_wall_thickness) * (-K7 - 6 * K8));
  result["S2_Maximum_compressional_stress_Cir_Leg"] = roundToTwo(SL2_Cir);

  result["Sum_of_Stress4_Leg"] = roundToTwo(SL2_Cir + Stress);

  return result;
};

export const Lug_Support_Calc = (input) => {
  var W_Weight = parseFloat(input.W_Weight_of_vessel_pounds_Lug) || 0;
  var n_number_of_legs = parseFloat(input.n_number_of_legs_Lug) || 1;
  var Q_Load_on_One_Leg = W_Weight / n_number_of_legs;
  var R_Radius_of_Head = parseFloat(input.R_Radius_of_Head_Lug) || 0;
  var H_Lever_arm_of_Load = parseFloat(input.H_Lever_arm_of_Load_Lug) || 0;
  var wear_plate_2A = parseFloat(input.Dim_wear_plate_2A_Lug) || 0;
  var wear_plate_A = wear_plate_2A / 2;
  var wear_plate_2B = parseFloat(input.Dim_wear_plate_2B_Lug) || 0;
  var wear_plate_B = wear_plate_2B / 2;
  var S_Stress = parseFloat(input.S_Stress_Lug) || 0;
  var P_Design_Pressure = parseFloat(input.P_Design_Pressure_Lug) || 0;
  var E_Joint_Efficiency = parseFloat(input.E_Joint_Efficiency_Lug) || 0;
  var t_wall_thickness = parseFloat(input.t_wall_thickness_Lug) || 0;
  var Yeild_Point = parseFloat(input.Yield_Point_Lug) || 0;

  var K1 = 2.8, K2 = 0.025, K3 = 6.8, K4 = 0.021;
  var C1 = 1, C2 = 1, C3 = 1, C4 = 1;

  var result = {};
  result["Q_Load_on_One_Leg_Lug"] = roundToTwo(Q_Load_on_One_Leg);

  var R_T_Value = R_Radius_of_Head / t_wall_thickness;
  var B_A_Value = wear_plate_B / wear_plate_A;
  var D_Value = (wear_plate_A / R_Radius_of_Head) * Math.pow(B_A_Value, 0.33);

  var S1_Part1 = (Q_Load_on_One_Leg * H_Lever_arm_of_Load) / (D_Value * R_Radius_of_Head * R_Radius_of_Head * t_wall_thickness);
  var S1_Part2 = C1 * K1;
  var S1_Part3 = (6 * K2 * R_Radius_of_Head) / (C2 * t_wall_thickness);
  var S1_Part4 = D_Value / (2 * (1.17 + B_A_Value));
  var S1_Part5 = (R_Radius_of_Head * R_Radius_of_Head) / (H_Lever_arm_of_Load * wear_plate_A);

  var S1_Max_tensile = S1_Part1 * (S1_Part2 + S1_Part3 + S1_Part4 * S1_Part5);
  result["S1_Maximum_tensile_stress_Long_Lug"] = roundToTwo(S1_Max_tensile);

  var Stress = (P_Design_Pressure * R_Radius_of_Head) / (2 * t_wall_thickness);
  result["Stress_Lug"] = roundToTwo(Stress);

  result["Sum_of_Stress_Lug"] = roundToTwo(S1_Max_tensile + Stress);

  var S2_Part1 = (Q_Load_on_One_Leg * H_Lever_arm_of_Load) / (D_Value * R_Radius_of_Head * R_Radius_of_Head * t_wall_thickness);
  var S2_Part2 = C3 * K3;
  var S2_Part3 = (6 * K4 * R_Radius_of_Head) / (C4 * t_wall_thickness);

  var S2_Max_Circ = S2_Part1 * (S2_Part2 + S2_Part3);
  result["S2_Maximum_Circumferential_stress_Long_Lug"] = roundToTwo(S2_Max_Circ);

  return result;
};

export default {
  roundToTwo,
  getFlangeMAWP,
  getMDMT,
  Cylindrical_Shell_Calc,
  Elliptical_Head_Calc,
  Shell_Calc,
  Nozzle_Calc_1,
  Saddle_Zick_Calc,
  shellEstimation,
  nozzleEstimation,
  Wind_Load,
  Seismic_Load,
  Deflection,
  Skirt_Support,
  Anchor_Bolt,
  Base_Ring,
  Combination_of_Stress,
  Torispherical_Head_Calc,
  Sphere_Hemispherical_Head_Calc,
  Flat_Head_Calc,
  Conical_Shell_Calc,
  Stress_Moment_Calc,
  Leg_Support_Calc,
  Lug_Support_Calc,
};
